// extracted by mini-css-extract-plugin
module.exports = {"headerHeight":"62px","content-container":"full-page-editor__content-container___zdZKP"};